import { memo } from "react";

const History = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0001 1.66669C14.6026 1.66669 18.3334 5.39752 18.3334 10C18.3334 14.6025 14.6026 18.3334 10.0001 18.3334C5.39758 18.3334 1.66675 14.6025 1.66675 10H3.33341C3.33341 13.6817 6.31841 16.6667 10.0001 16.6667C13.6817 16.6667 16.6667 13.6817 16.6667 10C16.6667 6.31835 13.6817 3.33335 10.0001 3.33335C7.70841 3.33335 5.68675 4.48919 4.48758 6.25002H6.66675V7.91669H1.66675V2.91669H3.33341V5.00002C4.85341 2.97502 7.27425 1.66669 10.0001 1.66669ZM10.8334 5.83335V9.65419L13.5359 12.3567L12.3567 13.5359L9.16675 10.3442V5.83335H10.8334Z"
      fill="currentColor"
    />
  </svg>
);

export default memo(History);
